import { app } from '../../../../app';

app.factory('SmsNumber', SmsNumber);

/** @ngInject */
function SmsNumber($resource) {
    return $resource('app/rest/phonenumbers/:id/checkPin', {}, {
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/list/sms-number.service.js